<!-- Donut Chart Card -->
<m-card>
  <div
    header
    class="flex flex-col xl:flex-row justify-between items-start xl:items-center w-full">
    <span class="sh2 mb-2 xl:!mb-0">Spend Allocation</span>

    <!-- Dropdown Component -->
    <m-dropdown
      class="w-full xl:w-auto"
      [options]="dimensionsOptions"
      [(ngModel)]="dimensions"
      (onChange)="onDimensionsChange($event?.value)"
      [disabled]="isLoading"></m-dropdown>
  </div>

  <!-- Chart -->
  <div class="flex flex-col items-center justify-center h-full text-center">
    <!-- Loading State -->
    @if (!isChartReady) {
      <m-skeleton
        width="190px"
        height="190px"
        shape="circle"
        class="my-8"></m-skeleton>
    }

    <!-- Empty State -->
    @if (!isLoading && isChartDataEmpty) {
      <m-not-available></m-not-available>
    }

    <!-- Chart -->
    <div class="my-3">
      @if (isChartReady && !isChartDataEmpty) {
        <m-donut-chart
          (click)="navigateToPage()"
          [data]="donutChartOptions?.data"
          [innerContent]="donutChartOptions?.innerContent"
          [height]="250">
        </m-donut-chart>
      }
    </div>

    <!-- Legend -->
    <div class="flex flex-wrap justify-evenly w-[15rem]">
      <!-- Skeleton Loaders -->
      @if (!isChartReady) {
        @for (item of [].constructor(6); track item; let i = $index) {
          <m-skeleton
            width="4.6875rem"
            height="1.25rem"
            class="mb-1"></m-skeleton>
        }
      }

      <!-- Chart Legends -->
      @for (legend of chartLegend; track legend) {
        <div class="flex items-center mr-2 mb-1">
          <span
            class="mr-1"
            [style.color]="legend?.color"
            style="font-size: 0.875rem; line-height: 1"
            >&#x25CF;</span
          >
          <span class="c1 text-gray-800">{{ legend?.name }}</span>
        </div>
      }
    </div>
  </div>
</m-card>
